<div class="rs-layout">
  <div class="rs-layout__header">
    <rs-header></rs-header>
  </div>
  <div class="rs-layout__content">
    <router-outlet></router-outlet>
  </div>
</div>
